module.exports = __webpack_public_path__ + "static/media/variable_costs.ef9db6fa.png";